<template>
  <h2>
    {{ $t(`landingPage.${text}`) }}
  </h2>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    childClass: {
      type: String,
      default: 'sm:text-4.1xl sm:leading-46 ',
    },
  },
  data: function () {
    return {
      landingPage: 'landingPage',
    }
  },
}
</script>
